import React, { useState, useEffect, useRef } from 'react';
import {
  getOrder,
  trackOrder,
  trackExchangeShipment,
  addDelhiveryWaybill,
  addExchangeWaybill,
  createDelhiveryShipment,
  createExchangeShipment,
  cancelDelhiveryShipment,
  cancelExchangeShipment,
  createReturnPickup,
  cancelReturnPickup,
  setExchangeReversePickupWaybill,
  updateOrderStage,
  simulateDeliveryStatus,
  approveReturn,
  approveExchange,
  rejectExchange,
} from '../services/orderService';
import getOptimizedUrl from '../utils/imageUtils';
import { calculateShippingQuoteFromSubtotal } from '../utils/shippingUtils';
import { refundPayment, refundRazorpayItem, getPaymentDetails, processCODRefund, confirmCODRefund } from '../services/paymentService';
import toast from 'react-hot-toast';
import { showErrorToast } from '../utils/errorHandler';

// ─── Icons ────────────────────────────────────────────────────────────────────
const Icons = {
  Close: () => <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>,
  Refresh: () => <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" /></svg>,
  Box: () => <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" /></svg>,
  Truck: () => <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" /></svg>,
  User: () => <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>,
  CreditCard: () => <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" /></svg>,
  Copy: () => <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" /></svg>,
  Sync: () => <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" /></svg>,
  Alert: () => <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>,
  CheckCircle: () => <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>,
  Info: () => <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>,
  Undo: () => <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6" /></svg>,
  Beaker: () => <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" /></svg>,
  MapPin: () => <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>,
  Package: () => <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" /></svg>,
  ChevronRight: () => <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>,
  ExternalLink: () => <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" /></svg>,
};

// ─── Stage Config ─────────────────────────────────────────────────────────────
const STAGE_LABELS = {
  ordered: 'Ordered', being_made: 'Being Made', shipped: 'Shipped',
  delivered: 'Delivered', cancelled: 'Cancelled', return_requested: 'Return Requested',
  return_approved: 'Return Approved', return_processing: 'Return In Transit',
  return_received_to_store: 'Return Received', refund_initiated: 'Refund Initiated',
};
const PRIMARY_ORDER_FLOW = ['ordered', 'being_made', 'shipped', 'delivered'];
const RETURN_FLOW_STAGES = ['return_requested', 'return_approved', 'return_processing', 'return_received_to_store', 'refund_initiated'];
const formatStageLabel = (stage = 'ordered') => STAGE_LABELS[stage] || String(stage).replace(/_/g, ' ');

// ─── Stage color map ──────────────────────────────────────────────────────────
const stageMeta = {
  ordered:                  { dot: 'bg-amber-400',   badge: 'bg-amber-50 text-amber-700 border-amber-200',   pill: 'bg-amber-100' },
  being_made:               { dot: 'bg-orange-400',  badge: 'bg-orange-50 text-orange-700 border-orange-200', pill: 'bg-orange-100' },
  shipped:                  { dot: 'bg-blue-500',    badge: 'bg-blue-50 text-blue-700 border-blue-200',       pill: 'bg-blue-100' },
  delivered:                { dot: 'bg-emerald-500', badge: 'bg-emerald-50 text-emerald-700 border-emerald-200', pill: 'bg-emerald-100' },
  cancelled:                { dot: 'bg-red-400',     badge: 'bg-red-50 text-red-700 border-red-200',          pill: 'bg-red-100' },
  return_requested:         { dot: 'bg-amber-500',   badge: 'bg-amber-50 text-amber-700 border-amber-200',    pill: 'bg-amber-100' },
  return_approved:          { dot: 'bg-amber-500',   badge: 'bg-amber-50 text-amber-700 border-amber-200',    pill: 'bg-amber-100' },
  return_processing:        { dot: 'bg-indigo-500',  badge: 'bg-indigo-50 text-indigo-700 border-indigo-200', pill: 'bg-indigo-100' },
  return_received_to_store: { dot: 'bg-slate-500',   badge: 'bg-slate-50 text-slate-700 border-slate-200',    pill: 'bg-slate-100' },
  refund_initiated:         { dot: 'bg-purple-500',  badge: 'bg-purple-50 text-purple-700 border-purple-200', pill: 'bg-purple-100' },
};

// ─── Small reusable atoms ────────────────────────────────────────────────────

const StatusBadge = ({ status, order }) => {
  const meta = stageMeta[status] || { badge: 'bg-gray-50 text-gray-600 border-gray-200' };
  const label = status === 'cancelled' && (order?.cancelledBy === 'user' || order?.cancelledBy === 'customer')
    ? 'Cancelled by customer'
    : formatStageLabel(status);
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-semibold border ${meta.badge}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${meta.dot || 'bg-gray-400'}`} />
      {label}
    </span>
  );
};

const Card = ({ children, className = '' }) => (
  <div className={`bg-white rounded-2xl border border-gray-100 shadow-sm ${className}`}>{children}</div>
);

const CardHeader = ({ title, action }) => (
  <div className="flex items-center justify-between px-5 py-4 border-b border-gray-50">
    <h3 className="text-xs font-bold text-gray-400 uppercase tracking-widest">{title}</h3>
    {action}
  </div>
);

const Btn = ({ children, variant = 'default', size = 'md', className = '', ...props }) => {
  const base = 'inline-flex items-center justify-center gap-1.5 font-semibold rounded-xl transition-all duration-150 disabled:opacity-40 disabled:cursor-not-allowed';
  const variants = {
    primary:   'bg-gray-900 text-white hover:bg-gray-700 shadow-sm',
    danger:    'bg-red-600 text-white hover:bg-red-700 shadow-sm',
    dangerSoft:'bg-red-50 text-red-700 border border-red-200 hover:bg-red-100',
    success:   'bg-emerald-600 text-white hover:bg-emerald-700 shadow-sm',
    blue:      'bg-blue-600 text-white hover:bg-blue-700 shadow-sm',
    soft:      'bg-gray-100 text-gray-700 hover:bg-gray-200',
    outline:   'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50 shadow-sm',
    ghost:     'text-gray-500 hover:text-gray-900 hover:bg-gray-100',
  };
  const sizes = { sm: 'px-3 py-1.5 text-xs', md: 'px-4 py-2 text-sm', lg: 'px-5 py-2.5 text-sm' };
  return (
    <button className={`${base} ${variants[variant]} ${sizes[size]} ${className}`} {...props}>
      {children}
    </button>
  );
};

const Input = ({ placeholder, value, onChange, className = '' }) => (
  <input
    type="text"
    placeholder={placeholder}
    value={value}
    onChange={onChange}
    className={`w-full px-3 py-2 text-sm border border-gray-200 rounded-xl bg-gray-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-gray-900/10 focus:border-gray-300 transition-all placeholder:text-gray-400 ${className}`}
  />
);

const Spinner = ({ size = 4 }) => (
  <span className={`block w-${size} h-${size} rounded-full border-2 border-current border-t-transparent animate-spin`} />
);

const InfoRow = ({ label, value, mono, children, copyText, onCopy }) => (
  <div className="flex items-start justify-between gap-3 py-2.5 border-b border-gray-50 last:border-0">
    <span className="text-xs text-gray-400 font-medium shrink-0 pt-0.5 w-28">{label}</span>
    <div className="flex items-center gap-2 flex-1 justify-end">
      <span className={`text-sm text-gray-900 text-right ${mono ? 'font-mono' : 'font-medium'}`}>
        {children || value || '—'}
      </span>
      {copyText && (
        <button onClick={onCopy} className="shrink-0 p-1 text-gray-300 hover:text-gray-600 rounded transition-colors">
          <Icons.Copy />
        </button>
      )}
    </div>
  </div>
);

const downloadInvoiceFromNode = async ({ receiptNode, orderId }) => {
  try {
    if (!receiptNode || !orderId) return;

    const html2canvas = (await import('html2canvas')).default;
    const clone = receiptNode.cloneNode(true);
    const images = clone.querySelectorAll('img');

    const imagePromises = Array.from(images).map(async (img, index) => {
      const originalImg = receiptNode.querySelectorAll('img')[index];
      const originalSrc = originalImg?.src || '';

      if (originalSrc.includes('amazonaws.com')) {
        try {
          const response = await fetch(`${process.env.REACT_APP_API_URL}/receipt/proxy-image`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ imageUrl: originalSrc }),
          });

          if (response.ok) {
            const { dataUrl } = await response.json();
            img.src = dataUrl;
          } else {
            const placeholder = document.createElement('div');
            placeholder.style.width = getComputedStyle(img).width;
            placeholder.style.height = getComputedStyle(img).height;
            placeholder.style.backgroundColor = '#f3f4f6';
            img.parentNode?.replaceChild(placeholder, img);
          }
        } catch (error) {
          const placeholder = document.createElement('div');
          placeholder.style.width = getComputedStyle(img).width;
          placeholder.style.height = getComputedStyle(img).height;
          placeholder.style.backgroundColor = '#f3f4f6';
          img.parentNode?.replaceChild(placeholder, img);
        }
      }
    });

    await Promise.all(imagePromises);

    const receiptContent = clone.querySelector('.max-w-sm');
    if (receiptContent) {
      receiptContent.classList.add('px-6');
    }

    clone.style.position = 'absolute';
    clone.style.left = '-9999px';
    document.body.appendChild(clone);

    await new Promise((resolve) => setTimeout(resolve, 100));

    const canvas = await html2canvas(clone, {
      scale: 2,
      backgroundColor: '#ffffff',
      logging: false,
    });

    document.body.removeChild(clone);

    canvas.toBlob((blob) => {
      if (!blob) return;
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `invoice-${orderId.slice(-6).toUpperCase()}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    });
  } catch (error) {
    console.error('Failed to download invoice:', error);
    alert('Failed to download invoice. Please try again.');
  }
};

// ─── Main Component ───────────────────────────────────────────────────────────
const AdminOrderDetails = ({ orderId, onClose, initialTab = 'overview' }) => {
  const [order, setOrder] = useState(null);
  const [trackingData, setTrackingData] = useState(null);
  const [exchangeTrackingData, setExchangeTrackingData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(initialTab || 'overview');

  const [waybillInput, setWaybillInput] = useState('');
  const [exchangeWaybillInput, setExchangeWaybillInput] = useState('');
  const [returnPickupAwbInput, setReturnPickupAwbInput] = useState('');
  const [exchangeReversePickupAwbInput, setExchangeReversePickupAwbInput] = useState('');
  const [actionLoading, setActionLoading] = useState(false);
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);
  const [showCancelExchangeConfirm, setShowCancelExchangeConfirm] = useState(false);
  const [showCancelReturnPickupConfirm, setShowCancelReturnPickupConfirm] = useState(false);
  const [showRefundConfirm, setShowRefundConfirm] = useState(false);
  const [confirmTxMap, setConfirmTxMap] = useState({});
  const [partialRefundMap, setPartialRefundMap] = useState({});
  const [isPollingExchangeReversePickup, setIsPollingExchangeReversePickup] = useState(false);
  const invoiceRef = useRef(null);

  useEffect(() => { if (orderId) fetchOrderDetails(); }, [orderId]);

  useEffect(() => {
    setActiveTab(initialTab || 'overview');
  }, [initialTab, orderId]);

  useEffect(() => {
    if (!order?.delhivery?.waybill || order.orderStage !== 'shipped') return;
    fetchTrackingData();
    const interval = setInterval(fetchTrackingData, 30000);
    return () => clearInterval(interval);
  }, [order?.orderStage, order?.delhivery?.waybill]);

  useEffect(() => {
    if (!order?.delhivery?.exchangeWaybill || order?.delhivery?.exchangeDeliveredAt) return;
    fetchExchangeTrackingData();
    const interval = setInterval(fetchExchangeTrackingData, 30000);
    return () => clearInterval(interval);
  }, [order?.delhivery?.exchangeWaybill, order?.delhivery?.exchangeDeliveredAt]);

  const fetchTrackingData = async () => {
    if (!order?.delhivery?.waybill) return;
    try {
      const tracking = await trackOrder(orderId);
      if (tracking?.order) {
        setOrder(tracking.order);
        setTrackingData(tracking);
        if (tracking.order.orderStage === 'delivered' && order.orderStage !== 'delivered') {
          toast.success('🎉 Order automatically marked as delivered by Delhivery!', { duration: 5000 });
        }
      }
    } catch (err) { console.error('Auto-sync tracking failed:', err); }
  };

  const fetchExchangeTrackingData = async () => {
    if (!order?.delhivery?.exchangeWaybill) return;
    try {
      const tracking = await trackExchangeShipment(orderId);
      if (tracking?.order) { setOrder(tracking.order); setExchangeTrackingData(tracking); }
    } catch (err) { console.error('Auto-sync exchange tracking failed:', err); }
  };

  const fetchOrderDetails = async () => {
    setLoading(true);
    try {
      const orderData = await getOrder(orderId);
      setOrder(orderData);
      setTrackingData(null);
      setExchangeTrackingData(null);
      if (orderData.delhivery?.waybill) {
        try { const t = await trackOrder(orderId); setTrackingData(t); if (t?.order) setOrder(t.order); } catch (e) {}
      }
      if (orderData.delhivery?.exchangeWaybill) {
        try { const t = await trackExchangeShipment(orderId); setExchangeTrackingData(t); if (t?.order) setOrder(t.order); } catch (e) {}
      }
    } catch (error) { showErrorToast(error, 'Failed to fetch order details'); }
    finally { setLoading(false); }
  };

  const handleCreateShipment = async () => {
    setActionLoading(true);
    try {
      const result = await createDelhiveryShipment(orderId);
      toast.success(`Shipment created! AWB: ${result.order.delhivery.waybill}`, { duration: 5000 });
      await fetchOrderDetails();
    } catch (error) {
      showErrorToast(error, 'Failed to create shipment', { duration: 6000 });
    } finally { setActionLoading(false); }
  };

  const handleAddWaybill = async () => {
    if (!waybillInput.trim()) return toast.error('Enter waybill number');
    setActionLoading(true);
    try { await addDelhiveryWaybill(orderId, waybillInput); toast.success('Waybill added'); setWaybillInput(''); await fetchOrderDetails(); }
    catch (e) { showErrorToast(e, 'Failed to add waybill'); } finally { setActionLoading(false); }
  };

  const handleCancelShipment = async () => {
    setActionLoading(true);
    try {
      await cancelDelhiveryShipment(orderId);
      toast.success('Shipment cancelled successfully', { duration: 5000 });
      setShowCancelConfirm(false);
      await fetchOrderDetails();
    } catch (error) {
      showErrorToast(error, 'Failed to cancel shipment', { duration: 6000 });
    } finally { setActionLoading(false); }
  };

  const handleCreateExchangeShipment = async () => {
    setActionLoading(true);
    try {
      const result = await createExchangeShipment(orderId);
      const awb = result?.order?.delhivery?.exchangeWaybill;
      toast.success(awb ? `Exchange shipment created. AWB: ${awb}` : 'Exchange replacement shipment created', { duration: 5000 });
      setExchangeWaybillInput('');
      await fetchOrderDetails();
    } catch (error) {
      showErrorToast(error, 'Failed to create exchange replacement shipment', { duration: 6000 });
    } finally { setActionLoading(false); }
  };

  const handleAddExchangeWaybill = async () => {
    const waybill = exchangeWaybillInput.trim();
    if (!waybill) return toast.error('Enter replacement AWB number');
    setActionLoading(true);
    try { await addExchangeWaybill(orderId, waybill); toast.success('Replacement AWB added'); setExchangeWaybillInput(''); await fetchOrderDetails(); }
    catch (error) { showErrorToast(error, 'Failed to add replacement AWB', { duration: 6000 }); }
    finally { setActionLoading(false); }
  };

  const handleCancelExchangeShipment = async () => {
    setActionLoading(true);
    try {
      const result = await cancelExchangeShipment(orderId);
      toast.success(result?.message || 'Exchange replacement shipment cancelled', { duration: 5000 });
      setShowCancelExchangeConfirm(false);
      await fetchOrderDetails();
    } catch (error) {
      showErrorToast(error, 'Failed to cancel exchange replacement shipment', { duration: 6000 });
    } finally { setActionLoading(false); }
  };

  const handleCreateReturnPickup = async () => {
    setActionLoading(true);
    try {
      const manualAwb = returnPickupAwbInput.trim();
      if (manualAwb) {
        const result = await updateOrderStage(orderId, 'return_processing', null, manualAwb);
        setOrder(result.order);
        toast.success(`Return pickup AWB saved: ${manualAwb}`, { duration: 5000 });
      } else {
        const result = await createReturnPickup(orderId);
        const awb = result?.order?.delhivery?.returnPickupWaybill;
        toast.success(awb ? `Return pickup created. AWB: ${awb}` : 'Return pickup created', { duration: 5000 });
      }
      setReturnPickupAwbInput('');
      await fetchOrderDetails();
    } catch (error) {
      showErrorToast(error, 'Failed to create return pickup', { duration: 6000 });
    } finally { setActionLoading(false); }
  };

  const handleCancelReturnPickup = async () => {
    setActionLoading(true);
    try {
      await cancelReturnPickup(orderId);
      toast.success('Return pickup cancelled', { duration: 5000 });
      setShowCancelReturnPickupConfirm(false);
      await fetchOrderDetails();
    } catch (error) {
      showErrorToast(error, 'Failed to cancel return pickup', { duration: 6000 });
    } finally { setActionLoading(false); }
  };

  const handleSimulateStatus = async (status) => {
    setActionLoading(true);
    try { await simulateDeliveryStatus(orderId, status); toast.success(`Simulated: ${status.replace('_', ' ').toUpperCase()}`); await fetchOrderDetails(); }
    catch (e) { showErrorToast(e, 'Failed to simulate status'); } finally { setActionLoading(false); }
  };

  const handleApproveReturn = async (itemId) => {
    setActionLoading(true);
    try { await approveReturn(orderId, itemId); toast.success('Return request approved!'); await fetchOrderDetails(); }
    catch (error) { showErrorToast(error, 'Failed to approve return'); } finally { setActionLoading(false); }
  };

  const handleApproveExchange = async (itemId) => {
    setActionLoading(true);
    try { await approveExchange(orderId, itemId); toast.success('Exchange request approved!'); await fetchOrderDetails(); }
    catch (error) { showErrorToast(error, 'Failed to approve exchange'); } finally { setActionLoading(false); }
  };

  const handleRejectExchange = async (itemId) => {
    setActionLoading(true);
    try { await rejectExchange(orderId, itemId); toast.success('Marked as Exchange Not Possible'); await fetchOrderDetails(); }
    catch (error) { showErrorToast(error, 'Failed to mark exchange as not possible'); } finally { setActionLoading(false); }
  };

  const handleSetExchangeReversePickupWaybill = async () => {
    const waybill = exchangeReversePickupAwbInput.trim();
    if (!waybill) return toast.error('Please enter a valid reverse pickup waybill');
    setActionLoading(true);
    setIsPollingExchangeReversePickup(true);
    try {
      await setExchangeReversePickupWaybill(orderId, waybill);
      toast.success(`Reverse pickup AWB ${waybill} saved!`);
      setExchangeReversePickupAwbInput('');
      await fetchOrderDetails();
    } catch (error) { showErrorToast(error, 'Failed to set reverse pickup waybill'); }
    finally { setActionLoading(false); setIsPollingExchangeReversePickup(true); }
  };

  const handleDispatchReplacementParcel = async () => {
    if (!window.confirm('Dispatch the replacement parcel now?')) return;
    setActionLoading(true);
    try { await createExchangeShipment(orderId); toast.success('Replacement shipment created!'); await fetchOrderDetails(); }
    catch (error) { showErrorToast(error, 'Failed to create replacement shipment'); }
    finally { setActionLoading(false); }
  };

  const handleSyncPayment = async () => {
    if (!order.paymentResult?.razorpay_payment_id) return;
    const toastId = toast.loading('Syncing with Razorpay...');
    try {
      const details = await getPaymentDetails(order.paymentResult.razorpay_payment_id);
      toast.success(`Status: ${details.payment.status}`, { id: toastId });
      await fetchOrderDetails();
    } catch (e) { showErrorToast(e, 'Failed to sync payment', { id: toastId }); }
  };

  const handleDownloadInvoice = async () => {
    await downloadInvoiceFromNode({ receiptNode: invoiceRef.current, orderId: order._id });
  };

  const handleRefund = async () => {
    if (!order.paymentResult?.razorpay_payment_id) return;
    setActionLoading(true);
    const toastId = toast.loading('Processing refund...');
    try {
      await refundPayment(order.paymentResult.razorpay_payment_id, order.totalPrice, order._id);
      await updateOrderStage(orderId, 'refund_initiated');
      toast.success('Refund processed successfully', { id: toastId });
      setShowRefundConfirm(false);
      await fetchOrderDetails();
    } catch (error) { showErrorToast(error, 'Refund failed', { id: toastId }); }
    finally { setActionLoading(false); }
  };

  const handleRefundItem = async (item) => {
    const defaultAmount = Number(
      item.refundDetails?.refundAmount ??
      (Number(item.price || 0) * Number(item.returnQuantity || item.quantity || 1))
    );
    const amount = Number(partialRefundMap[item._id] ?? defaultAmount);

    if (!Number.isFinite(amount) || amount <= 0) {
      toast.error('Enter a valid refund amount');
      return;
    }

    if (!window.confirm(`Refund ₹${amount.toFixed(2)} for ${item.productName}?`)) return;

    setActionLoading(true);
    const toastId = toast.loading('Processing item refund...');
    try {
      await refundRazorpayItem(order._id, item._id, amount);
      toast.success('Item refund initiated', { id: toastId });
      setPartialRefundMap(prev => ({ ...prev, [item._id]: '' }));
      await fetchOrderDetails();
    } catch (error) {
      showErrorToast(error, 'Item refund failed', { id: toastId });
    } finally {
      setActionLoading(false);
    }
  };

  const handleInitiateCODRefund = async (item, itemIndex) => {
    const refundAmount = item.price * (item.returnQuantity || 1);
    if (!window.confirm(`Process ₹${refundAmount.toFixed(2)} refund to ${item.refundDetails?.bankName || 'bank account'}?`)) return;
    setActionLoading(true);
    const toastId = toast.loading('Processing COD refund...');
    try {
      await processCODRefund(order._id, item._id, {
        accountNumber: item.refundDetails.bankAccount, bankName: item.refundDetails.bankName,
        ifscCode: item.refundDetails.ifscCode, accountHolderName: item.refundDetails.accountHolderName,
      }, refundAmount);
      toast.success(`Refund of ₹${refundAmount.toFixed(2)} initiated!`, { id: toastId });
      await fetchOrderDetails();
    } catch (error) { showErrorToast(error, 'Failed to process COD refund', { id: toastId }); }
    finally { setActionLoading(false); }
  };

  const handleConfirmCODRefund = async (item, itemIndex) => {
    try {
      const tx = String(confirmTxMap[item._id] || '').trim();
      if (!tx) {
        toast.error('Please enter transaction id');
        return;
      }

      const refundAmount = item.price * (item.returnQuantity || 1);
      const toastId = toast.loading('Confirming manual refund...');

      await confirmCODRefund(order._id, item._id, tx, refundAmount);

      toast.success('Refund confirmed and customer notified', { id: toastId });
      setConfirmTxMap(prev => ({ ...prev, [item._id]: '' }));
      await fetchOrderDetails();
    } catch (err) {
      showErrorToast(err, 'Failed to confirm refund');
    }
  };

  const handleStageChange = async (newStage, options = {}) => {
    setActionLoading(true);
    try {
      const result = await updateOrderStage(orderId, newStage, options.awbNumber || null, options.returnPickupAwb || null);
      setOrder(result.order);
      toast.success(`Stage updated to ${formatStageLabel(newStage)}`);
      await fetchOrderDetails();
    } catch (error) { showErrorToast(error, 'Failed to update order stage'); }
    finally { setActionLoading(false); }
  };

  const formatDate = (ds) => {
    if (!ds) return 'N/A';
    return new Date(ds).toLocaleString('en-IN', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  };
  const copyToClipboard = (text) => { navigator.clipboard.writeText(text); toast.success('Copied'); };

  // ── Loading / Error ────────────────────────────────────────────────────────
  if (loading) return (
    <div className="flex h-full items-center justify-center bg-gray-50">
      <div className="flex flex-col items-center gap-3">
        <div className="w-8 h-8 rounded-full border-2 border-gray-900 border-t-transparent animate-spin" />
        <p className="text-sm text-gray-400 font-medium">Loading order…</p>
      </div>
    </div>
  );
  if (!order) return (
    <div className="flex h-full items-center justify-center">
      <p className="text-gray-400 text-sm">Order not found</p>
    </div>
  );

  const currentStage = order.orderStage || 'ordered';
  const hasPrimaryFlowCompleted = PRIMARY_ORDER_FLOW.includes(currentStage);
  const inReturnFlow = RETURN_FLOW_STAGES.includes(currentStage);
  const canCancelOrder = ['ordered', 'being_made'].includes(currentStage);
  const canCreateShipment = currentStage === 'being_made' && !order.delhivery?.waybill;
  const exchangeWaybill = order.delhivery?.exchangeWaybill;
  const hasActiveExchangeShipment = Boolean(exchangeWaybill);
  const exchangeDeliveredAt = order.delhivery?.exchangeDeliveredAt;
  const exchangeShipmentStatus = order.delhivery?.exchangeShipmentStatus || 'Pending Manifest';
  const latestExchangeScan = exchangeTrackingData?.trackingData?.ShipmentData?.[0]?.Shipment?.Scans?.[0]?.ScanDetail;
  const itemSummary = (() => {
    const items = order.items || [];
    const cancelled = items.filter(item => item.cancelledStatus === 'cancelled');
    const returned = items.filter(item => item.returnStatus && item.returnStatus !== 'none' && item.returnStatus !== 'rejected');
    const exchanged = items.filter(item => item.exchangeStatus && item.exchangeStatus !== 'none' && item.exchangeStatus !== 'rejected');
    const refunded = items.filter(item => item.refundDetails?.refundStatus && item.refundDetails.refundStatus !== 'none');
    return { cancelled, returned, exchanged, refunded };
  })();
  const isRazorpayOrder = order.paymentMethod === 'Razorpay' || order.paymentResult?.razorpay_payment_id;
  const refundEligibleItems = (order.items || []).filter(item =>
    isRazorpayOrder && (
      item.cancelledStatus === 'cancelled' ||
      item.returnStatus === 'approved' ||
      item.returnStatus === 'completed'
    )
  );
  const invoiceItems = (order.items || []).filter((item) =>
    item.cancelledStatus !== 'cancelled' &&
    (!item.returnStatus || item.returnStatus === 'none' || item.returnStatus === 'rejected') &&
    (!item.exchangeStatus || item.exchangeStatus === 'none' || item.exchangeStatus === 'rejected')
  );
  const invoicePricedItems = invoiceItems.map((item) => {
    const quantity = Number(item.quantity || 0);
    const discountedUnitPrice = Number(item.discountedPrice ?? item.price ?? 0);
    const originalUnitPrice = Number(item.originalPrice ?? item.unitMrp ?? item.mrp ?? discountedUnitPrice);
    const safeOriginalUnitPrice = Number.isFinite(originalUnitPrice) && originalUnitPrice > 0 ? originalUnitPrice : discountedUnitPrice;
    const lineOriginalAmount = safeOriginalUnitPrice * quantity;
    const lineDiscountedAmount = discountedUnitPrice * quantity;
    const lineItemDiscount = Math.max(0, lineOriginalAmount - lineDiscountedAmount);

    return {
      ...item,
      quantity,
      discountedUnitPrice,
      originalUnitPrice: safeOriginalUnitPrice,
      lineOriginalAmount,
      lineDiscountedAmount,
      lineItemDiscount,
    };
  });
  const invoiceItemsSubtotal = invoicePricedItems.reduce((sum, item) => sum + item.lineDiscountedAmount, 0);
  const invoiceItemDiscountTotal = Math.max(
    invoicePricedItems.reduce((sum, item) => sum + item.lineItemDiscount, 0),
    Number(order.itemDiscountTotal || 0)
  );
  const invoiceOriginalSubtotal = invoiceItemsSubtotal + invoiceItemDiscountTotal;
  const invoiceCouponDiscount = Number(order.couponDiscount || 0);
  const invoiceShipping = Number.isFinite(Number(order.shippingPrice))
    ? Number(order.shippingPrice)
    : Number(calculateShippingQuoteFromSubtotal(invoiceItemsSubtotal).shippingPrice || 0);
  const invoiceGrandTotal = invoiceItemsSubtotal - invoiceCouponDiscount + (order.taxPrice || 0) + invoiceShipping;

  const tabs = [
    { id: 'overview', label: 'Overview', icon: '◉' },
    { id: 'items',    label: 'Items',    icon: '☰' },
    { id: 'shipping', label: 'Shipping', icon: '↗' },
    { id: 'payment',  label: 'Payment',  icon: '₹' },
    { id: 'customer', label: 'Customer', icon: '◎' },
  ];

  return (
    <div className="bg-gray-50 h-full flex flex-col text-sm font-sans antialiased">

      {/* ── TOP HEADER ─────────────────────────────────────────────────────── */}
      <div className="bg-white border-b border-gray-100 px-6 py-4 flex items-center justify-between sticky top-0 z-20">
        <div className="flex items-center gap-4">
          <div>
            <div className="flex items-center gap-2.5 mb-1">
              <span className="text-[11px] font-bold text-gray-400 uppercase tracking-widest">Order</span>
              <span className="text-base font-bold text-gray-900 tracking-tight">#{order._id.slice(-6).toUpperCase()}</span>
              <StatusBadge status={order.orderStage} order={order} />
            </div>
            <p className="text-xs text-gray-400">
              {formatDate(order.createdAt)} &nbsp;·&nbsp; via <span className="font-semibold text-gray-600">{order.paymentMethod}</span>
            </p>
          </div>
        </div>
        <div className="flex items-center gap-1.5">
          <Btn variant="outline" size="sm" onClick={handleDownloadInvoice} disabled={actionLoading} title="Download invoice">
            Download Invoice
          </Btn>
          <Btn variant="ghost" size="sm" onClick={fetchOrderDetails} title="Refresh">
            <Icons.Refresh /> Refresh
          </Btn>
          {order?.delhivery?.returnPickupWaybill && (
            <Btn variant="dangerSoft" size="sm" onClick={() => setShowCancelReturnPickupConfirm(true)} disabled={actionLoading}>
              Cancel Return Pickup
            </Btn>
          )}
          <div className="w-px h-5 bg-gray-200 mx-1" />
          <Btn variant="ghost" size="sm" onClick={onClose} className="text-gray-400 hover:text-red-600 hover:bg-red-50">
            <Icons.Close />
          </Btn>
        </div>
      </div>

      {/* ── TABS ───────────────────────────────────────────────────────────── */}
      <div className="bg-white border-b border-gray-100 px-6 sticky top-[69px] z-10">
        <nav className="flex gap-0">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-1.5 px-4 py-3 text-xs font-semibold border-b-2 transition-all duration-150 whitespace-nowrap
                ${activeTab === tab.id
                  ? 'border-gray-900 text-gray-900'
                  : 'border-transparent text-gray-400 hover:text-gray-700 hover:border-gray-200'}`}
            >
              <span className="text-[11px] opacity-70">{tab.icon}</span>
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* ── SCROLLABLE BODY ────────────────────────────────────────────────── */}
      <div className="flex-1 overflow-y-auto p-5 min-h-0">

        {/* ══════════════════════════════════════════════════════════════════
            TAB: OVERVIEW
        ════════════════════════════════════════════════════════════════════ */}
        {activeTab === 'overview' && (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 items-start">

            {/* LEFT COLUMN */}
            <div className="lg:col-span-2 space-y-4">

              {/* Financial Summary */}
              <Card>
                <CardHeader title="Financial Summary" />
                <div className="p-5 space-y-2">
                  <InfoRow label="Subtotal" value={`₹${order.itemsPrice?.toFixed(2)}`} mono />
                  {order.totalDiscount > 0 && (
                    <>
                      {order.couponCode && (
                        <InfoRow label="Coupon" value={`-₹${order.couponDiscount?.toFixed(2)}`}>
                          <span className="text-xs font-semibold text-red-600">{order.couponCode}</span>
                        </InfoRow>
                      )}
                      {order.itemDiscountTotal > 0 && (
                        <InfoRow label="Item Discount" value={`-₹${order.itemDiscountTotal?.toFixed(2)}`} mono />
                      )}
                    </>
                  )}
                  <InfoRow label="Tax" value={`₹${order.taxPrice?.toFixed(2)}`} mono />
                  <InfoRow label="Shipping" value={order.shippingPrice === 0 ? 'Free' : `₹${order.shippingPrice?.toFixed(2)}`} mono />
                  <div className="border-t border-gray-100 pt-2 mt-2">
                    <div className="flex items-center justify-between">
                      <span className="text-xs font-bold text-gray-600 uppercase tracking-widest">Total</span>
                      <span className="text-lg font-bold text-gray-900">₹{order.totalPrice?.toFixed(2)}</span>
                    </div>
                  </div>
                </div>
              </Card>

              {/* Item Status Summary */}
              {(itemSummary.cancelled.length > 0 || itemSummary.returned.length > 0 || itemSummary.exchanged.length > 0 || itemSummary.refunded.length > 0) && (
                <div className="rounded-2xl bg-amber-50 border border-amber-200 p-4">
                  <div className="flex gap-3">
                    <span className="text-amber-500 shrink-0 mt-0.5"><Icons.Alert /></span>
                    <div className="w-full">
                      <p className="text-xs font-bold text-amber-900 uppercase tracking-wide mb-2">Item activity summary</p>
                      <div className="flex flex-wrap gap-2 mb-3">
                        {itemSummary.cancelled.length > 0 && <span className="text-[11px] font-semibold rounded-full bg-red-100 text-red-700 px-2.5 py-1">{itemSummary.cancelled.length} cancelled</span>}
                        {itemSummary.returned.length > 0 && <span className="text-[11px] font-semibold rounded-full bg-indigo-100 text-indigo-700 px-2.5 py-1">{itemSummary.returned.length} returned</span>}
                        {itemSummary.exchanged.length > 0 && <span className="text-[11px] font-semibold rounded-full bg-blue-100 text-blue-700 px-2.5 py-1">{itemSummary.exchanged.length} exchanged</span>}
                        {itemSummary.refunded.length > 0 && <span className="text-[11px] font-semibold rounded-full bg-emerald-100 text-emerald-700 px-2.5 py-1">{itemSummary.refunded.length} refunded</span>}
                      </div>
                      {isRazorpayOrder && refundEligibleItems.length > 0 && (
                        <p className="text-sm text-amber-800">Some cancelled or returned items can be refunded from the <strong>Payment</strong> tab.</p>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* Items preview */}
              <Card>
                <CardHeader title={`Items (${order.items?.length || 0})`} />
                <div className="divide-y divide-gray-50">
                  {order.items?.map((item, i) => (
                    <div key={i} className={`flex items-center gap-4 px-5 py-3.5 hover:bg-gray-50/50 transition-colors ${item.cancelledStatus === 'cancelled' ? 'opacity-50' : ''}`}>
                      {item.image
                        ? <img src={getOptimizedUrl(item.image, 200)} alt="" className="w-11 h-11 rounded-xl object-cover border border-gray-100 shrink-0" />
                        : <div className="w-11 h-11 rounded-xl bg-gray-100 flex items-center justify-center text-gray-300 shrink-0"><Icons.Box /></div>
                      }
                      <div className="flex-1 min-w-0">
                        <p className={`text-sm font-semibold text-gray-900 truncate ${item.cancelledStatus === 'cancelled' ? 'line-through' : ''}`}>{item.productName}</p>
                        <div className="flex items-center gap-1.5 mt-0.5 flex-wrap">
                          {item.size && <span className="text-[10px] bg-gray-100 text-gray-600 px-1.5 py-0.5 rounded font-medium">Size {item.size}</span>}
                          {item.customSize && <span className="text-[10px] bg-amber-100 text-amber-700 px-1.5 py-0.5 rounded font-medium">Custom: {item.customSize}</span>}
                          {item.cancelledStatus === 'cancelled' && <span className="text-[10px] bg-red-100 text-red-700 px-1.5 py-0.5 rounded font-medium">Cancelled</span>}
                        </div>
                      </div>
                      <div className="text-right shrink-0">
                        <p className="text-sm font-bold text-gray-900">₹{(item.price * item.quantity).toFixed(2)}</p>
                        <p className="text-[11px] text-gray-400 font-mono">×{item.quantity}</p>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="px-5 py-3 bg-gray-50/50 rounded-b-2xl border-t border-gray-50">
                  <button onClick={() => setActiveTab('items')} className="text-xs font-semibold text-gray-500 hover:text-gray-900 flex items-center gap-1 transition-colors">
                    View full item details <Icons.ChevronRight />
                  </button>
                </div>
              </Card>
            </div>

            {/* RIGHT COLUMN */}
            <div className="space-y-4 overflow-y-auto max-h-[calc(100vh-220px)] pr-2">

              {/* ── Stage card ── */}
              <Card>
                <CardHeader title="Order Stage" />
                <div className="p-5 space-y-4">
                  {/* Current stage display */}
                  <div className={`rounded-xl p-4 flex items-center gap-3 ${stageMeta[currentStage]?.pill || 'bg-gray-100'}`}>
                    <span className={`w-3 h-3 rounded-full shrink-0 ${stageMeta[currentStage]?.dot || 'bg-gray-400'} ${currentStage === 'shipped' ? 'animate-pulse' : ''}`} />
                    <div>
                      <p className="text-xs text-gray-500 font-medium">Current stage</p>
                      <p className="text-base font-bold text-gray-900">{formatStageLabel(currentStage)}</p>
                    </div>
                  </div>

                  {/* Next actions */}
                  <div className="space-y-2">
                    {currentStage === 'ordered' && (
                      <Btn variant="primary" className="w-full" onClick={() => handleStageChange('being_made')} disabled={actionLoading}>
                        {actionLoading ? <Spinner /> : null} Accept → Move to Being Made
                      </Btn>
                    )}

                    {currentStage === 'being_made' && !order.delhivery?.waybill && (
                      <div className="text-xs text-blue-700 bg-blue-50 rounded-xl p-3 leading-relaxed border border-blue-100">
                        Order accepted. Once packed, create a shipment in the <strong>Tracking</strong> card below.
                      </div>
                    )}

                    {currentStage === 'shipped' && order.delhivery?.waybill && (
                      <div className="flex items-start gap-2 text-xs text-emerald-700 bg-emerald-50 rounded-xl p-3 border border-emerald-100">
                        <span className="mt-0.5 shrink-0"><Icons.Sync /></span>
                        <span><strong>Auto-sync active</strong> — updates every 30 s. Will auto-mark delivered on confirmation.</span>
                      </div>
                    )}

                    {PRIMARY_ORDER_FLOW.includes(currentStage) && currentStage !== 'delivered' && !inReturnFlow && (
                      <Btn variant="success" className="w-full" onClick={() => handleStageChange('delivered')} disabled={actionLoading}>
                        {actionLoading ? <Spinner /> : <Icons.CheckCircle />} Mark as Delivered
                      </Btn>
                    )}

                    {currentStage === 'delivered' && (
                      <div className="rounded-xl bg-emerald-50 border border-emerald-200 p-4 text-center">
                        <p className="text-sm font-bold text-emerald-800 flex items-center justify-center gap-1.5">
                          <Icons.CheckCircle /> Order Delivered
                        </p>
                        {order.deliveredAt && <p className="text-xs text-emerald-600 mt-1">{formatDate(order.deliveredAt)}</p>}
                      </div>
                    )}

                    {inReturnFlow && (
                      <div className="text-xs text-amber-700 bg-amber-50 rounded-xl p-3 border border-amber-100">
                        Return / refund workflow active. Manage via the request cards below.
                      </div>
                    )}

                    {canCancelOrder && (
                      <>
                        <div className="border-t border-gray-100 pt-2" />
                        <Btn variant="dangerSoft" className="w-full" onClick={() => handleStageChange('cancelled')} disabled={actionLoading}>
                          Cancel Order
                        </Btn>
                      </>
                    )}
                  </div>
                </div>
              </Card>

              {/* ── Tracking / Shipment card ── */}
              <Card>
                <CardHeader title="Shipment" />
                <div className="p-5 space-y-3">
                  {!order.delhivery?.waybill ? (
                    <>
                      {!canCreateShipment ? (
                        <p className="text-xs text-gray-500 bg-gray-50 rounded-xl p-3 border border-gray-100">
                          {currentStage === 'ordered' && 'Accept order first (Being Made), then create shipment.'}
                          {inReturnFlow && 'Shipment creation disabled during return workflow.'}
                          {currentStage !== 'ordered' && !inReturnFlow && currentStage !== 'being_made' && 'Shipment can only be created in Being Made stage.'}
                        </p>
                      ) : (
                        <>
                          <Btn variant="primary" className="w-full" onClick={handleCreateShipment} disabled={actionLoading}>
                            {actionLoading ? <><Spinner /> Creating…</> : <><Icons.Box /> Create Delhivery Shipment</>}
                          </Btn>

                          <div className="relative">
                            <div className="absolute inset-0 flex items-center"><div className="w-full border-t border-gray-100" /></div>
                            <div className="relative flex justify-center"><span className="bg-white px-2 text-[10px] text-gray-400 uppercase tracking-wider font-semibold">or enter manually</span></div>
                          </div>

                          <div className="space-y-2">
                            <Input placeholder="Paste existing AWB number" value={waybillInput} onChange={e => setWaybillInput(e.target.value)} />
                            <Btn variant="outline" size="sm" className="w-full" onClick={handleAddWaybill} disabled={actionLoading}>
                              Save AWB & Mark Shipped
                            </Btn>
                          </div>

                          <div className="bg-amber-50 border border-amber-100 rounded-xl p-3 text-xs text-amber-700 space-y-1">
                            <p className="font-semibold">Label & Invoice reminder</p>
                            <p>• Shipping slip = Delhivery AWB label from their dashboard.</p>
                            <p>• Invoice sticker = your own tax invoice print.</p>
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {order.delhivery.waybill.startsWith('TEST') && (
                        <div className="flex items-center gap-2 text-xs bg-violet-50 text-violet-700 border border-violet-100 rounded-xl p-3 font-semibold">
                          <Icons.Beaker /> Test Mode Active
                        </div>
                      )}

                      {/* AWB pill */}
                      <div className="flex items-center justify-between bg-gray-50 rounded-xl p-3 border border-gray-100">
                        <div>
                          <p className="text-[10px] text-gray-400 font-bold uppercase tracking-widest mb-0.5">Active AWB</p>
                          <p className="font-mono font-bold text-gray-900 text-base tracking-tight">{order.delhivery.waybill}</p>
                        </div>
                        <button onClick={() => copyToClipboard(order.delhivery.waybill)} className="p-2 hover:bg-gray-200 rounded-lg transition-colors text-gray-400 hover:text-gray-700">
                          <Icons.Copy />
                        </button>
                      </div>

                      {/* Tracking link */}
                      <div className="bg-blue-50 border border-blue-100 rounded-xl p-3 space-y-2">
                        <p className="text-xs font-bold text-blue-800">Customer Tracking Link</p>
                        <p className="text-[10px] text-blue-600 leading-relaxed">Works via API immediately. Delhivery's website may take several hours.</p>
                        <Btn variant="blue" size="sm" className="w-full" onClick={() => { copyToClipboard(`https://www.delhivery.com/track-v2/package/${order.delhivery.waybill}`); toast.success('Link copied!'); }}>
                          <Icons.Copy /> Copy Tracking Link
                        </Btn>
                      </div>

                      {/* Test mode simulate */}
                      {order.delhivery.waybill.startsWith('TEST') && (
                        <div className="rounded-xl border border-gray-100 bg-white p-3">
                          <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-2">Simulate Status</p>
                          <div className="grid grid-cols-2 gap-1.5">
                            {[
                              { status: 'picked_up',      label: 'Picked Up',       icon: <Icons.Box /> },
                              { status: 'in_transit',     label: 'In Transit',      icon: <Icons.Truck /> },
                              { status: 'out_for_delivery',label: 'Out for Del.',   icon: <Icons.Truck /> },
                              { status: 'delivered',      label: 'Delivered',       icon: <Icons.CheckCircle /> },
                            ].map(s => (
                              <button key={s.status} onClick={() => handleSimulateStatus(s.status)} disabled={actionLoading}
                                className="flex items-center justify-center gap-1 px-2 py-2 text-xs font-semibold rounded-lg bg-gray-50 hover:bg-gray-100 text-gray-700 border border-gray-100 transition-colors disabled:opacity-40">
                                {s.icon} {s.label}
                              </button>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* Cancel shipment */}
                      {!showCancelConfirm ? (
                        <Btn variant="dangerSoft" size="sm" className="w-full" onClick={() => setShowCancelConfirm(true)} disabled={actionLoading}>
                          Cancel Shipment on Delhivery
                        </Btn>
                      ) : (
                        <div className="rounded-xl bg-red-50 border border-red-100 p-4 space-y-3">
                          <p className="text-xs font-bold text-red-800">⚠️ Cancel this shipment on Delhivery?</p>
                          <p className="text-xs text-red-600">AWB will be removed and order reverted to Being Made.</p>
                          <div className="flex gap-2">
                            <Btn variant="danger" size="sm" className="flex-1" onClick={handleCancelShipment} disabled={actionLoading}>
                              {actionLoading ? <Spinner /> : null} Yes, Cancel
                            </Btn>
                            <Btn variant="outline" size="sm" className="flex-1" onClick={() => setShowCancelConfirm(false)} disabled={actionLoading}>
                              Keep
                            </Btn>
                          </div>
                        </div>
                      )}

                      {order.delhivery?.lastCancelledWaybill && (
                        <div className="text-xs text-gray-500 bg-orange-50 border border-orange-100 rounded-xl p-3">
                          <span className="font-semibold text-orange-700">Previous:</span> AWB <code className="font-mono">{order.delhivery.lastCancelledWaybill}</code> was cancelled{order.delhivery.lastCancelledAt && ` on ${formatDate(order.delhivery.lastCancelledAt)}`}.
                        </div>
                      )}
                    </>
                  )}
                </div>
              </Card>

              {/* ── Return / Exchange requests ── */}
              {(() => {
                const returnRequests   = order.items?.filter(i => i.returnStatus === 'requested') || [];
                const exchangeRequests = order.items?.filter(i => i.exchangeStatus === 'requested') || [];
                const approvedReturns  = order.items?.filter(i => i.returnStatus === 'approved') || [];
                const approvedExchanges= order.items?.filter(i => i.exchangeStatus === 'approved') || [];
                const completedExchanges = order.items?.filter(i => i.exchangeStatus === 'completed') || [];
                const rejectedExchanges  = order.items?.filter(i => i.exchangeStatus === 'rejected') || [];

                if (!returnRequests.length && !exchangeRequests.length && !approvedReturns.length && !approvedExchanges.length && !completedExchanges.length && !rejectedExchanges.length) return null;

                return (
                  <div className="space-y-4">

                    {/* ─ Pending requests ─ */}
                    {(returnRequests.length > 0 || exchangeRequests.length > 0) && (
                      <Card>
                        <div className="px-5 py-3 bg-amber-50 rounded-t-2xl border-b border-amber-100 flex items-center gap-2">
                          <Icons.Alert />
                          <span className="text-xs font-bold text-amber-900 uppercase tracking-wide">Pending Requests</span>
                          <span className="ml-auto bg-amber-200 text-amber-800 text-[10px] font-bold px-2 py-0.5 rounded-full">{returnRequests.length + exchangeRequests.length}</span>
                        </div>
                        <div className="p-4 space-y-3">
                          {returnRequests.map(item => (
                            <div key={item._id} className="rounded-xl border border-gray-100 p-4 space-y-3 bg-white">
                              <div className="flex gap-3">
                                {item.image && <img src={getOptimizedUrl(item.image, 100)} alt="" className="w-14 h-14 object-cover rounded-xl border border-gray-100 shrink-0" />}
                                <div className="flex-1 min-w-0">
                                  <p className="font-semibold text-gray-900 text-sm">{item.productName}</p>
                                  <p className="text-xs text-gray-400 mt-0.5">Size {item.size} · Qty {item.quantity}</p>
                                  <div className="mt-2 bg-red-50 rounded-lg px-3 py-2 border border-red-100">
                                    <p className="text-[10px] font-bold text-red-700 uppercase tracking-wide">Return reason</p>
                                    <p className="text-xs text-red-800 mt-0.5">"{item.returnReason || 'Not specified'}"</p>
                                  </div>
                                </div>
                              </div>
                              <Btn variant="success" className="w-full" size="sm" onClick={() => handleApproveReturn(item._id)} disabled={actionLoading}>
                                <Icons.CheckCircle /> Approve Return
                              </Btn>
                            </div>
                          ))}

                          {exchangeRequests.map(item => (
                            <div key={item._id} className="rounded-xl border border-gray-100 p-4 space-y-3 bg-white">
                              <div className="flex gap-3">
                                {item.image && <img src={getOptimizedUrl(item.image, 100)} alt="" className="w-14 h-14 object-cover rounded-xl border border-gray-100 shrink-0" />}
                                <div className="flex-1 min-w-0">
                                  <p className="font-semibold text-gray-900 text-sm">{item.productName}</p>
                                  <p className="text-xs text-gray-400 mt-0.5">Size {item.size} · Qty {item.quantity}</p>
                                  <div className="mt-2 bg-blue-50 rounded-lg px-3 py-2 border border-blue-100 space-y-0.5">
                                    <p className="text-[10px] font-bold text-blue-700 uppercase tracking-wide">Exchange request</p>
                                    <p className="text-xs text-blue-800"><strong>New size:</strong> {item.exchangeSize || 'Not specified'}</p>
                                    <p className="text-xs text-blue-800"><strong>Reason:</strong> "{item.exchangeReason || 'Not specified'}"</p>
                                  </div>
                                </div>
                              </div>
                              <div className="grid grid-cols-2 gap-2">
                                <Btn variant="blue" size="sm" onClick={() => handleApproveExchange(item._id)} disabled={actionLoading}>
                                  <Icons.CheckCircle /> Approve
                                </Btn>
                                <Btn variant="soft" size="sm" onClick={() => handleRejectExchange(item._id)} disabled={actionLoading}>
                                  Not Possible
                                </Btn>
                              </div>
                            </div>
                          ))}
                        </div>
                      </Card>
                    )}

                    {/* ─ Approved returns (pure return, no exchange) ─ */}
                    {approvedReturns.length > 0 && (
                      <Card>
                        <div className="px-5 py-3 bg-emerald-50 rounded-t-2xl border-b border-emerald-100 flex items-center gap-2">
                          <Icons.CheckCircle />
                          <span className="text-xs font-bold text-emerald-900 uppercase tracking-wide">Return Approved</span>
                          <span className="ml-auto text-[10px] bg-emerald-200 text-emerald-800 font-bold px-2 py-0.5 rounded-full">{approvedReturns.length} item{approvedReturns.length > 1 ? 's' : ''}</span>
                        </div>
                        <div className="p-4 space-y-3">
                          {/* Items list */}
                          {approvedReturns.map((item) => (
                            <div key={item._id} className="flex items-center gap-3 rounded-xl border border-gray-100 px-3 py-2.5 bg-gray-50/50">
                              {item.image && <img src={getOptimizedUrl(item.image, 100)} alt="" className="w-10 h-10 object-cover rounded-lg border border-gray-100 shrink-0" />}
                              <div className="flex-1 min-w-0">
                                <p className="font-semibold text-gray-900 text-sm truncate">{item.productName}</p>
                                <p className="text-xs text-gray-400 mt-0.5">Size {item.size} · Qty {item.quantity}</p>
                              </div>
                            </div>
                          ))}

                          {/* Return pickup AWB section — ONE per order */}
                          <div className="border-t border-gray-100 pt-3">
                            {order?.delhivery?.returnPickupWaybill ? (
                              /* AWB exists — show it with cancel option */
                              <div className="rounded-xl border border-emerald-100 bg-emerald-50 p-3 space-y-2">
                                <p className="text-[10px] font-bold text-emerald-700 uppercase tracking-widest">Return Pickup Active</p>
                                <div className="flex items-center gap-2 flex-wrap">
                                  <span className="text-xs text-gray-600 font-medium">AWB:</span>
                                  <a href={`https://www.delhivery.com/track-v2/package/${order.delhivery.returnPickupWaybill}`} target="_blank" rel="noopener noreferrer"
                                    className="text-xs font-mono font-bold text-blue-600 hover:underline flex items-center gap-0.5">
                                    {order.delhivery.returnPickupWaybill} <Icons.ExternalLink />
                                  </a>
                                  <button onClick={() => copyToClipboard(order.delhivery.returnPickupWaybill)} className="p-1 text-gray-400 hover:text-gray-700"><Icons.Copy /></button>
                                </div>
                                <Btn variant="dangerSoft" size="sm" className="w-full" onClick={() => setShowCancelReturnPickupConfirm(true)} disabled={actionLoading}>
                                  Cancel Pickup
                                </Btn>
                              </div>
                            ) : (
                              /* No AWB yet — let admin create or enter manually */
                              <div className="rounded-xl border border-gray-200 bg-white p-3 space-y-2">
                                <p className="text-xs font-bold text-gray-700">Schedule return pickup from customer</p>
                                <p className="text-[10px] text-gray-400">Leave AWB empty to auto-create via Delhivery API. Enter manually if you already created it in the Delhivery panel.</p>
                                <Input placeholder="Manual AWB (optional)" value={returnPickupAwbInput} onChange={e => setReturnPickupAwbInput(e.target.value)} />
                                <Btn variant="success" size="sm" className="w-full" onClick={handleCreateReturnPickup} disabled={actionLoading}>
                                  {actionLoading ? <Spinner /> : null}
                                  {returnPickupAwbInput.trim() ? 'Save Manual Return AWB' : 'Create Return Pickup (Auto AWB)'}
                                </Btn>
                              </div>
                            )}
                          </div>

                          {/* What happens next — inform admin */}
                          <div className="rounded-xl bg-blue-50 border border-blue-100 p-3">
                            <p className="text-[10px] font-bold text-blue-700 uppercase tracking-widest mb-1">What happens next?</p>
                            <p className="text-xs text-blue-700 leading-relaxed">Once the returned item arrives at your warehouse, receive it and process a refund from the <strong>Payment</strong> tab.</p>
                          </div>
                        </div>
                      </Card>
                    )}

                    {/* ─ Approved exchanges ─ */}
                    {approvedExchanges.length > 0 && (
                      <Card>
                        <div className="px-5 py-3 bg-blue-50 rounded-t-2xl border-b border-blue-100 flex items-center gap-2">
                          <Icons.Info />
                          <span className="text-xs font-bold text-blue-900 uppercase tracking-wide">Approved Exchanges</span>
                          <span className="ml-auto text-[10px] bg-blue-200 text-blue-800 font-bold px-2 py-0.5 rounded-full">{approvedExchanges.length} item{approvedExchanges.length > 1 ? 's' : ''}</span>
                        </div>
                        <div className="p-4 space-y-4">

                          {/* Items being exchanged */}
                          {approvedExchanges.map(item => (
                            <div key={item._id} className="flex items-center gap-3 rounded-xl border border-gray-100 px-3 py-2.5 bg-gray-50/50">
                              {item.image && <img src={getOptimizedUrl(item.image, 100)} alt="" className="w-10 h-10 object-cover rounded-lg border border-gray-100 shrink-0" />}
                              <div className="flex-1 min-w-0">
                                <p className="font-semibold text-sm text-gray-900 truncate">{item.productName}</p>
                                <p className="text-xs text-gray-500 mt-0.5">
                                  <span className="line-through text-gray-400">{item.size}</span>
                                  <span className="mx-1 text-gray-400">→</span>
                                  <span className="font-bold text-blue-700">{item.exchangeSize}</span>
                                </p>
                              </div>
                              <span className="text-[10px] bg-blue-50 text-blue-700 border border-blue-100 px-2 py-1 rounded-full font-bold shrink-0">
                                {hasActiveExchangeShipment ? 'Replacement sent' : 'Awaiting shipment'}
                              </span>
                            </div>
                          ))}

                          {/* ── STEP 1: Return pickup ── */}
                          <div className={`rounded-xl border p-3 space-y-2 ${order?.delhivery?.returnPickupWaybill ? 'border-emerald-100 bg-emerald-50' : 'border-amber-100 bg-amber-50'}`}>
                            <div className="flex items-center gap-2">
                              <span className={`w-5 h-5 rounded-full text-[10px] font-bold flex items-center justify-center shrink-0 ${order?.delhivery?.returnPickupWaybill ? 'bg-emerald-500 text-white' : 'bg-amber-400 text-white'}`}>1</span>
                              <p className={`text-xs font-bold ${order?.delhivery?.returnPickupWaybill ? 'text-emerald-800' : 'text-amber-800'}`}>
                                {order?.delhivery?.returnPickupWaybill ? 'Return pickup scheduled ✓' : 'Schedule return pickup from customer'}
                              </p>
                            </div>
                            {order?.delhivery?.returnPickupWaybill ? (
                              <div className="flex items-center gap-2 flex-wrap pl-7">
                                <span className="text-xs text-gray-600 font-medium">AWB:</span>
                                <a href={`https://www.delhivery.com/track-v2/package/${order.delhivery.returnPickupWaybill}`} target="_blank" rel="noopener noreferrer"
                                  className="text-xs font-mono font-bold text-blue-600 hover:underline flex items-center gap-0.5">
                                  {order.delhivery.returnPickupWaybill} <Icons.ExternalLink />
                                </a>
                                <button onClick={() => copyToClipboard(order.delhivery.returnPickupWaybill)} className="p-1 text-gray-400 hover:text-gray-700"><Icons.Copy /></button>
                              </div>
                            ) : (
                              <div className="pl-7 space-y-2">
                                <Input placeholder="Manual AWB (optional)" value={returnPickupAwbInput} onChange={e => setReturnPickupAwbInput(e.target.value)} />
                                <Btn variant="primary" size="sm" className="w-full" onClick={handleCreateReturnPickup} disabled={actionLoading}>
                                  {actionLoading ? <Spinner /> : null}
                                  {returnPickupAwbInput.trim() ? 'Save Manual AWB' : 'Create Return Pickup (Auto AWB)'}
                                </Btn>
                                <p className="text-[10px] text-amber-700">Leave empty to auto-create via Delhivery API.</p>
                              </div>
                            )}
                          </div>

                          {/* ── STEP 2: Reverse pickup AWB (only relevant for exchange, after step 1) ── */}
                          {order?.delhivery?.returnPickupWaybill && (
                            <div className={`rounded-xl border p-3 space-y-2 ${order?.delhivery?.exchangeReversePickupWaybill ? 'border-purple-100 bg-purple-50' : 'border-purple-100 bg-white'}`}>
                              <div className="flex items-center gap-2">
                                <span className={`w-5 h-5 rounded-full text-[10px] font-bold flex items-center justify-center shrink-0 ${order?.delhivery?.exchangeReversePickupWaybill ? 'bg-purple-500 text-white' : 'bg-gray-200 text-gray-500'}`}>2</span>
                                <p className={`text-xs font-bold ${order?.delhivery?.exchangeReversePickupWaybill ? 'text-purple-800' : 'text-gray-600'}`}>
                                  {order?.delhivery?.exchangeReversePickupWaybill ? 'Reverse pickup AWB saved ✓' : 'Enter reverse pickup AWB (optional)'}
                                </p>
                              </div>
                              {order?.delhivery?.exchangeReversePickupWaybill ? (
                                <div className="flex items-center gap-2 flex-wrap pl-7">
                                  <a href={`https://www.delhivery.com/track-v2/package/${order.delhivery.exchangeReversePickupWaybill}`} target="_blank" rel="noopener noreferrer"
                                    className="text-xs font-mono font-bold text-purple-600 hover:underline flex items-center gap-0.5">
                                    {order.delhivery.exchangeReversePickupWaybill} <Icons.ExternalLink />
                                  </a>
                                  <span className="text-[10px] bg-purple-100 text-purple-700 border border-purple-100 px-2 py-0.5 rounded-full font-bold">
                                    {order.delhivery.exchangeReversePickupStatus || 'Awaiting Pickup'}
                                  </span>
                                </div>
                              ) : (
                                <div className="pl-7 space-y-2">
                                  <p className="text-[10px] text-gray-500 leading-relaxed">Only needed if you created a separate reverse shipment in Delhivery panel. Skip if using the same return pickup above.</p>
                                  <Input placeholder="Reverse pickup AWB from Delhivery (optional)" value={exchangeReversePickupAwbInput} onChange={e => setExchangeReversePickupAwbInput(e.target.value)} />
                                  <Btn variant="soft" size="sm" className="w-full" onClick={handleSetExchangeReversePickupWaybill} disabled={actionLoading || !exchangeReversePickupAwbInput.trim()}>
                                    {actionLoading ? <Spinner /> : null} Save Reverse AWB
                                  </Btn>
                                </div>
                              )}
                            </div>
                          )}

                          {/* ── STEP 3: Send replacement shipment ── */}
                          {order?.delhivery?.returnPickupWaybill && (
                            <div className={`rounded-xl border p-3 space-y-2 ${hasActiveExchangeShipment ? 'border-blue-100 bg-blue-50' : 'border-gray-200 bg-white'}`}>
                              <div className="flex items-center gap-2">
                                <span className={`w-5 h-5 rounded-full text-[10px] font-bold flex items-center justify-center shrink-0 ${hasActiveExchangeShipment ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-500'}`}>3</span>
                                <p className={`text-xs font-bold ${hasActiveExchangeShipment ? 'text-blue-800' : 'text-gray-700'}`}>
                                  {hasActiveExchangeShipment ? 'Replacement shipment created ✓' : 'Create replacement shipment for customer'}
                                </p>
                              </div>

                              {hasActiveExchangeShipment ? (
                                /* Active replacement shipment */
                                <div className="pl-7 space-y-2">
                                  <div className="flex items-center justify-between gap-2">
                                    <div>
                                      <p className="text-[10px] text-gray-400 font-bold uppercase tracking-widest">Replacement AWB</p>
                                      <p className="font-mono font-bold text-blue-700 text-sm mt-0.5">{exchangeWaybill}</p>
                                    </div>
                                    <span className="text-[10px] bg-blue-100 border border-blue-200 text-blue-700 px-2 py-0.5 rounded-full font-bold whitespace-nowrap">{exchangeShipmentStatus}</span>
                                  </div>
                                  <p className="text-xs text-gray-500">
                                    {exchangeDeliveredAt ? `Delivered on ${formatDate(exchangeDeliveredAt)}` : `Last scan: ${latestExchangeScan || 'Waiting for first scan…'}`}
                                  </p>
                                  <div className="flex gap-2">
                                    <Btn variant="outline" size="sm" className="flex-1" onClick={fetchExchangeTrackingData} disabled={actionLoading}><Icons.Refresh /> Refresh</Btn>
                                    <button onClick={() => { copyToClipboard(`https://www.delhivery.com/track-v2/package/${exchangeWaybill}`); toast.success('Link copied!'); }}
                                      className="flex-1 flex items-center justify-center gap-1 px-3 py-1.5 text-xs font-semibold bg-blue-50 border border-blue-200 text-blue-700 rounded-xl hover:bg-blue-100 transition-colors">
                                      <Icons.Copy /> Copy Link
                                    </button>
                                  </div>
                                  {!exchangeDeliveredAt && !showCancelExchangeConfirm && (
                                    <Btn variant="dangerSoft" size="sm" className="w-full" onClick={() => setShowCancelExchangeConfirm(true)} disabled={actionLoading}>
                                      Cancel Replacement Shipment
                                    </Btn>
                                  )}
                                  {showCancelExchangeConfirm && (
                                    <div className="rounded-xl bg-red-50 border border-red-100 p-3 space-y-2">
                                      <p className="text-xs text-red-800 font-medium">Cancel replacement shipment on Delhivery?</p>
                                      <div className="flex gap-2">
                                        <Btn variant="danger" size="sm" className="flex-1" onClick={handleCancelExchangeShipment} disabled={actionLoading}>
                                          {actionLoading ? <Spinner /> : null} Yes, Cancel
                                        </Btn>
                                        <Btn variant="outline" size="sm" className="flex-1" onClick={() => setShowCancelExchangeConfirm(false)}>Keep</Btn>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ) : (() => {
                                /* Check if reverse pickup was confirmed (if AWB was set) */
                                const reverseAwb = order?.delhivery?.exchangeReversePickupWaybill;
                                const reverseStatus = order?.delhivery?.exchangeReversePickupStatus?.toLowerCase() || '';
                                const reversePickedUp = reverseAwb && (reverseStatus.includes('picked') || reverseStatus.includes('collected') || reverseStatus.includes('dispatched'));
                                const reverseSetButWaiting = reverseAwb && !reversePickedUp;

                                if (reverseSetButWaiting) {
                                  return (
                                    <div className="pl-7">
                                      <p className="text-xs text-amber-700 bg-amber-50 rounded-lg px-3 py-2 border border-amber-100">
                                        ⏳ Waiting for carrier pickup… (<strong>{order.delhivery.exchangeReversePickupStatus || 'Awaiting Pickup'}</strong>)<br />
                                        <span className="text-[10px] text-amber-600 mt-1 block">You can also create the replacement shipment now without waiting.</span>
                                      </p>
                                      {/* Still show the button so admin can dispatch early */}
                                      <div className="mt-2 space-y-2">
                                        <Btn variant="success" className="w-full" size="sm" onClick={handleDispatchReplacementParcel} disabled={actionLoading}>
                                          {actionLoading ? <Spinner /> : <Icons.Truck />} Dispatch Replacement Now
                                        </Btn>
                                      </div>
                                    </div>
                                  );
                                }

                                /* Ready to dispatch — either reverse confirmed or no reverse AWB set */
                                return (
                                  <div className="pl-7 space-y-2">
                                    {reversePickedUp && (
                                      <p className="text-[10px] text-emerald-700 bg-emerald-50 rounded-lg px-3 py-1.5 border border-emerald-100">✓ Reverse pickup confirmed. Ready to dispatch!</p>
                                    )}
                                    <Btn variant="success" className="w-full" onClick={handleCreateExchangeShipment} disabled={actionLoading}>
                                      {actionLoading ? <Spinner /> : <Icons.Truck />} Create Replacement Shipment (Auto AWB)
                                    </Btn>
                                    <div className="flex gap-2">
                                      <Input placeholder="Manual replacement AWB" value={exchangeWaybillInput} onChange={e => setExchangeWaybillInput(e.target.value)} />
                                      <Btn variant="outline" size="sm" onClick={handleAddExchangeWaybill} disabled={actionLoading}>Save</Btn>
                                    </div>
                                    <p className="text-[10px] text-gray-400">Use manual AWB only if shipment was created outside this panel.</p>
                                  </div>
                                );
                              })()}
                            </div>
                          )}

                          {/* Prompt: return pickup is step 0 before anything */}
                          {!order?.delhivery?.returnPickupWaybill && (
                            <p className="text-xs text-gray-400 bg-gray-50 rounded-xl px-3 py-2 border border-gray-100">
                              Complete Step 1 (return pickup) first before creating the replacement shipment.
                            </p>
                          )}
                        </div>
                      </Card>
                    )}

                    {/* ─ Completed exchanges ─ */}
                    {completedExchanges.length > 0 && (
                      <Card>
                        <div className="px-5 py-3 bg-emerald-50 rounded-t-2xl border-b border-emerald-100 flex items-center gap-2">
                          <Icons.CheckCircle />
                          <span className="text-xs font-bold text-emerald-900 uppercase tracking-wide">Exchanges Completed</span>
                        </div>
                        <div className="p-4 space-y-2">
                          {exchangeWaybill && <p className="text-xs text-gray-500">AWB: <span className="font-mono font-semibold">{exchangeWaybill}</span>{exchangeDeliveredAt && ` · Delivered ${formatDate(exchangeDeliveredAt)}`}</p>}
                          {completedExchanges.map(item => (
                            <div key={item._id} className="flex items-center justify-between rounded-xl border border-gray-100 px-4 py-3">
                              <div>
                                <p className="text-sm font-semibold text-gray-900">{item.productName}</p>
                                <p className="text-xs text-gray-400"><span className="line-through">{item.size}</span> → <span className="font-bold text-emerald-700">{item.exchangeSize}</span></p>
                              </div>
                              <span className="text-[10px] bg-emerald-100 text-emerald-800 font-bold px-2 py-0.5 rounded-full">Done</span>
                            </div>
                          ))}
                        </div>
                      </Card>
                    )}

                    {/* ─ Rejected exchanges ─ */}
                    {rejectedExchanges.length > 0 && (
                      <Card>
                        <div className="px-5 py-3 bg-gray-50 rounded-t-2xl border-b border-gray-100 flex items-center gap-2">
                          <Icons.Info />
                          <span className="text-xs font-bold text-gray-500 uppercase tracking-wide">Exchange Not Possible</span>
                        </div>
                        <div className="p-4 space-y-2">
                          {rejectedExchanges.map(item => (
                            <div key={item._id} className="flex items-center justify-between rounded-xl border border-gray-100 px-4 py-3">
                              <div>
                                <p className="text-sm font-semibold text-gray-900">{item.productName}</p>
                                <p className="text-xs text-gray-400">{item.size} → {item.exchangeSize || 'N/A'}</p>
                              </div>
                              <span className="text-[10px] bg-gray-100 text-gray-600 font-bold px-2 py-0.5 rounded-full">Not Possible</span>
                            </div>
                          ))}
                        </div>
                      </Card>
                    )}
                  </div>
                );
              })()}
            </div>
          </div>
        )}

        {/* ══════════════════════════════════════════════════════════════════
            TAB: ITEMS
        ════════════════════════════════════════════════════════════════════ */}
        {activeTab === 'items' && (
          <Card>
            <div className="overflow-x-auto">
              <table className="w-full text-left min-w-[600px]">
                <thead>
                  <tr className="bg-gray-50 text-[10px] font-bold text-gray-400 uppercase tracking-widest border-b border-gray-100">
                    <th className="px-6 py-3">Product</th>
                    <th className="px-4 py-3">Attributes</th>
                    <th className="px-4 py-3">Status</th>
                    <th className="px-4 py-3 text-right">Price</th>
                    <th className="px-4 py-3 text-right">Qty</th>
                    <th className="px-6 py-3 text-right">Total</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-50">
                  {order.items?.map((item, idx) => (
                    <tr key={idx} className={`hover:bg-gray-50/50 transition-colors ${item.cancelledStatus === 'cancelled' ? 'opacity-50' : ''}`}>
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-3">
                          {item.image
                            ? <img src={getOptimizedUrl(item.image, 200)} alt="" className="w-12 h-12 rounded-xl object-cover border border-gray-100 shrink-0" />
                            : <div className="w-12 h-12 rounded-xl bg-gray-100 flex items-center justify-center text-gray-300 shrink-0"><Icons.Box /></div>
                          }
                          <div>
                            <p className={`text-sm font-semibold text-gray-900 ${item.cancelledStatus === 'cancelled' ? 'line-through' : ''}`}>{item.productName}</p>
                            <p className="text-[10px] text-gray-400 font-mono mt-0.5">{item.product}</p>
                          </div>
                        </div>
                      </td>
                      <td className="px-4 py-4">
                        <div className="flex flex-col gap-1">
                          {item.size && <span className="text-[10px] bg-gray-100 text-gray-700 px-1.5 py-0.5 rounded font-medium w-fit">Size: {item.size}</span>}
                          {item.color && <span className="text-[10px] bg-gray-100 text-gray-700 px-1.5 py-0.5 rounded font-medium w-fit">Color: {item.color}</span>}
                          {item.customSize && <span className="text-[10px] bg-amber-100 text-amber-700 px-1.5 py-0.5 rounded font-medium w-fit">Custom: {item.customSize}</span>}
                        </div>
                      </td>
                      <td className="px-4 py-4">
                        {item.cancelledStatus === 'cancelled' && <span className="text-[10px] bg-red-100 text-red-800 px-2 py-0.5 rounded-full font-bold">Cancelled</span>}
                        {item.returnStatus === 'requested' && <span className="text-[10px] bg-amber-100 text-amber-800 px-2 py-0.5 rounded-full font-bold">Return Req.</span>}
                        {item.returnStatus === 'approved' && <span className="text-[10px] bg-emerald-100 text-emerald-800 px-2 py-0.5 rounded-full font-bold">Return Appr.</span>}
                        {item.exchangeStatus === 'requested' && <span className="text-[10px] bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full font-bold">Exchange Req.</span>}
                        {item.exchangeStatus === 'approved' && <span className="text-[10px] bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full font-bold">Exchange Appr.</span>}
                        {item.exchangeStatus === 'completed' && <span className="text-[10px] bg-emerald-100 text-emerald-800 px-2 py-0.5 rounded-full font-bold">Exchange Done</span>}
                        {item.exchangeStatus === 'rejected' && <span className="text-[10px] bg-gray-100 text-gray-700 px-2 py-0.5 rounded-full font-bold">Not Possible</span>}
                        {!item.cancelledStatus && !item.returnStatus && !item.exchangeStatus && <span className="text-gray-300 text-xs">—</span>}
                      </td>
                      <td className="px-4 py-4 text-right font-mono text-sm text-gray-500">₹{item.price?.toFixed(2)}</td>
                      <td className="px-4 py-4 text-right font-mono text-sm text-gray-900">{item.quantity}</td>
                      <td className="px-6 py-4 text-right font-mono text-sm font-bold text-gray-900">₹{(item.price * item.quantity).toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot className="bg-gray-50 border-t border-gray-100">
                  <tr>
                    <td colSpan={5} className="px-6 py-3 text-right text-xs font-bold text-gray-400 uppercase tracking-widest">Order Total</td>
                    <td className="px-6 py-3 text-right font-mono font-bold text-gray-900">₹{order.totalPrice?.toFixed(2)}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </Card>
        )}

        {/* ══════════════════════════════════════════════════════════════════
            TAB: SHIPPING
        ════════════════════════════════════════════════════════════════════ */}
        {activeTab === 'shipping' && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {/* Address */}
            <Card className="h-fit">
              <CardHeader title="Delivery Address" />
              <div className="p-5">
                {order.shippingAddress ? (
                  <div className="space-y-4">
                    <div>
                      <p className="text-base font-bold text-gray-900">{order.shippingAddress.name}</p>
                      <p className="text-sm text-gray-600 mt-2 leading-relaxed">
                        {order.shippingAddress.line1}<br />
                        {order.shippingAddress.line2 && <>{order.shippingAddress.line2}<br /></>}
                        {order.shippingAddress.city}, {order.shippingAddress.state} {order.shippingAddress.postalCode}<br />
                        <span className="text-xs text-gray-400 uppercase tracking-wider">{order.shippingAddress.country}</span>
                      </p>
                    </div>
                    <div className="pt-3 border-t border-gray-50 space-y-2">
                      <div className="flex items-center gap-2.5">
                        <span className="w-7 h-7 rounded-lg bg-gray-100 flex items-center justify-center text-xs shrink-0">📞</span>
                        <span className="text-sm text-gray-700">{order.shippingAddress.phone}</span>
                      </div>
                      <div className="flex items-center gap-2.5">
                        <span className="w-7 h-7 rounded-lg bg-gray-100 flex items-center justify-center text-xs shrink-0">✉️</span>
                        <span className="text-sm text-gray-700 truncate">{order.shippingAddress.email}</span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <p className="text-gray-400 text-sm italic">No shipping address provided</p>
                )}
              </div>
            </Card>

            {/* Timeline */}
            <div className="md:col-span-2">
              <Card>
                <CardHeader
                  title="Shipment Timeline"
                  action={trackingData?.order?.delhivery?.expected_delivery_date && (
                    <span className="text-xs font-semibold text-emerald-700 bg-emerald-50 px-2.5 py-1 rounded-full border border-emerald-100">
                      ETA {formatDate(trackingData.order.delhivery.expected_delivery_date)}
                    </span>
                  )}
                />
                <div className="p-5">
                  {trackingData?.order?.delhivery?.scans?.length > 0 ? (
                    <div className="relative">
                      <div className="absolute left-[7px] top-2 bottom-2 w-px bg-gray-100" />
                      <div className="space-y-5">
                        {trackingData.order.delhivery.scans.map((scan, idx) => (
                          <div key={idx} className="relative pl-6 flex gap-4">
                            <div className={`absolute left-0 top-1 w-3.5 h-3.5 rounded-full border-2 border-white shadow-sm ${idx === 0 ? 'bg-gray-900' : 'bg-gray-200'}`} />
                            <div className="flex-1 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-1">
                              <div>
                                <p className={`text-sm font-semibold ${idx === 0 ? 'text-gray-900' : 'text-gray-500'}`}>{scan.ScanDetail?.Scan}</p>
                                {scan.ScanDetail?.ScannedLocation && (
                                  <p className="text-xs text-gray-400 mt-0.5 flex items-center gap-1"><Icons.MapPin /> {scan.ScanDetail.ScannedLocation}</p>
                                )}
                              </div>
                              <span className="text-[11px] font-mono text-gray-400 bg-gray-50 px-2 py-0.5 rounded border border-gray-100 whitespace-nowrap shrink-0">
                                {formatDate(scan.ScanDetail?.ScanDateTime)}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div className="flex flex-col items-center justify-center py-14 text-center">
                      <div className="w-12 h-12 rounded-2xl bg-gray-100 flex items-center justify-center text-gray-300 mb-3"><Icons.Truck /></div>
                      <p className="text-sm font-semibold text-gray-900">No tracking events yet</p>
                      <p className="text-xs text-gray-400 mt-1 max-w-xs">Updates appear here once the carrier scans the package.</p>
                    </div>
                  )}
                </div>
              </Card>
            </div>
          </div>
        )}

        {/* ══════════════════════════════════════════════════════════════════
            TAB: PAYMENT
        ════════════════════════════════════════════════════════════════════ */}
        {activeTab === 'payment' && (
          <div className="max-w-2xl space-y-4">
            <Card>
              <CardHeader title="Payment Overview" />
              <div className="p-5 space-y-0">
                <InfoRow label="Method" value={order.paymentMethod} />
                <InfoRow label="Stage"><StatusBadge status={order.orderStage} order={order} /></InfoRow>
                {order.paymentResult?.razorpay_payment_id && (
                  <>
                    <InfoRow label="Payment ID" mono copyText value={order.paymentResult.razorpay_payment_id} onCopy={() => copyToClipboard(order.paymentResult.razorpay_payment_id)} />
                    <InfoRow label="Razorpay Order" mono value={order.paymentResult.razorpay_order_id} />
                    <InfoRow label="Payer Email" value={order.paymentResult.email} />
                  </>
                )}
              </div>
              {order.paymentResult?.razorpay_payment_id && (
                <div className="px-5 pb-4">
                  <Btn variant="soft" size="sm" onClick={handleSyncPayment}>
                    <Icons.Sync /> Sync with Razorpay
                  </Btn>
                </div>
              )}
            </Card>

            {/* Refund */}
            {order.paymentResult?.razorpay_payment_id && !order.isRefunded && (
              <Card>
                <CardHeader title="Refund Management" />
                <div className="p-5">
                  {!showRefundConfirm ? (
                    <div className="flex items-center justify-between gap-4">
                      <div>
                        <p className="text-sm font-semibold text-gray-900">Initiate full refund</p>
                        <p className="text-xs text-gray-400 mt-0.5">Will reverse ₹{order.totalPrice} via Razorpay.</p>
                      </div>
                      <Btn variant="dangerSoft" size="sm" onClick={() => setShowRefundConfirm(true)}>
                        <Icons.Undo /> Refund
                      </Btn>
                    </div>
                  ) : (
                    <div className="rounded-xl bg-red-50 border border-red-100 p-4 space-y-3">
                      <p className="text-sm font-bold text-red-800">Confirm full refund of ₹{order.totalPrice}?</p>
                      <p className="text-xs text-red-600">This will immediately return the amount to the customer's original payment method.</p>
                      <div className="flex gap-2">
                        <Btn variant="danger" className="flex-1" onClick={handleRefund} disabled={actionLoading}>
                          {actionLoading ? <Spinner /> : null} Yes, Refund
                        </Btn>
                        <Btn variant="outline" className="flex-1" onClick={() => setShowRefundConfirm(false)} disabled={actionLoading}>Cancel</Btn>
                      </div>
                    </div>
                  )}
                </div>
              </Card>
            )}

            {/* Razorpay Item Refunds */}
            {isRazorpayOrder && refundEligibleItems.length > 0 && (
              <Card>
                <CardHeader title="Item Refund Management" />
                <div className="p-5 space-y-3">
                  {refundEligibleItems.map((item) => {
                    const defaultAmount = Number(
                      item.refundDetails?.refundAmount ??
                      (Number(item.price || 0) * Number(item.returnQuantity || item.quantity || 1))
                    ).toFixed(2);
                    const currentValue = partialRefundMap[item._id] ?? defaultAmount;
                    const isCompleted = item.refundDetails?.refundStatus === 'completed';

                    return (
                      <div key={item._id} className="rounded-xl border border-gray-100 p-4 space-y-3">
                        <div className="flex items-start justify-between gap-3">
                          <div>
                            <p className="text-sm font-semibold text-gray-900">{item.productName}</p>
                            <p className="text-xs text-gray-400">
                              {item.cancelledStatus === 'cancelled'
                                ? 'Cancelled item'
                                : item.returnStatus === 'completed'
                                  ? 'Returned item'
                                  : 'Approved return'}
                            </p>
                          </div>
                          <p className="text-base font-bold text-gray-900">₹{defaultAmount}</p>
                        </div>

                        <div className="flex flex-col sm:flex-row gap-2">
                          <Input
                            placeholder="Refund amount"
                            value={currentValue}
                            onChange={(e) => setPartialRefundMap(prev => ({ ...prev, [item._id]: e.target.value }))}
                          />
                          <Btn
                            variant="danger"
                            size="sm"
                            className="sm:w-auto w-full"
                            onClick={() => handleRefundItem(item)}
                            disabled={actionLoading || isCompleted}
                          >
                            {actionLoading ? <Spinner /> : <Icons.Undo />} {isCompleted ? 'Refunded' : 'Initiate Item Refund'}
                          </Btn>
                        </div>

                        <div className="flex items-center justify-between text-xs text-gray-500">
                          <span>Refund status: {String(item.refundDetails?.refundStatus || 'none').toUpperCase()}</span>
                          {item.refundDetails?.refundPaymentId && <span className="font-mono">{item.refundDetails.refundPaymentId}</span>}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </Card>
            )}

            {/* COD Refund */}
            {order.paymentMethod === 'COD' && order.hasReturnRequest && !order.isRefunded && (
              <Card>
                <CardHeader title="COD Refund Management" />
                <div className="p-5 space-y-3">
                  {order.items.filter(i => i.returnStatus === 'approved' && i.refundDetails).map((item, idx) => (
                    <div key={idx} className="rounded-xl border border-gray-100 p-4 space-y-3">
                      <div className="flex justify-between">
                        <div>
                          <p className="text-sm font-semibold text-gray-900">{item.productName}</p>
                          <p className="text-xs text-gray-400">Qty: {item.returnQuantity || 1}</p>
                        </div>
                        <p className="text-base font-bold text-gray-900">₹{(item.price * (item.returnQuantity || 1)).toFixed(2)}</p>
                      </div>
                      <div className="bg-gray-50 rounded-lg p-3 border border-gray-100 text-xs space-y-1">
                        <div className="flex justify-between"><span className="text-gray-400">Account</span><span className="font-mono">{item.refundDetails.bankAccount}</span></div>
                        <div className="flex justify-between"><span className="text-gray-400">Bank</span><span>{item.refundDetails.bankName}</span></div>
                        <div className="flex justify-between"><span className="text-gray-400">IFSC</span><span className="font-mono">{item.refundDetails.ifscCode}</span></div>
                        <div className="flex justify-between"><span className="text-gray-400">Holder</span><span>{item.refundDetails.accountHolderName}</span></div>
                      </div>
                      {(!item.refundDetails.refundStatus || item.refundDetails.refundStatus === 'none') ? (
                        <Btn variant="danger" size="sm" className="w-full" onClick={() => handleInitiateCODRefund(item, idx)} disabled={actionLoading}>
                          {actionLoading ? <Spinner /> : <Icons.Undo />} Initiate COD Refund
                        </Btn>
                      ) : (
                        (() => {
                          const status = item.refundDetails.refundStatus || 'pending';
                          if (['pending', 'processing', 'pending_manual'].includes(status)) {
                            return (
                              <div className="space-y-2">
                                <div className="flex gap-2">
                                  <Input placeholder="Transaction ID from bank" value={confirmTxMap[item._id] || ''} onChange={e => setConfirmTxMap(prev => ({ ...prev, [item._id]: e.target.value }))} />
                                  <Btn variant="primary" size="sm" onClick={() => handleConfirmCODRefund(item, idx)} disabled={actionLoading}>{actionLoading ? <Spinner /> : 'Confirm Refund'}</Btn>
                                </div>
                                <div className="text-xs text-amber-700">Refund marked pending. After manual transfer, enter transaction id to confirm and notify customer.</div>
                              </div>
                            );
                          }

                          return (
                            <div className={`rounded-lg px-3 py-2 text-xs font-bold text-center ${
                              status === 'completed' ? 'bg-emerald-50 text-emerald-800 border border-emerald-100' :
                              status === 'failed' ? 'bg-red-50 text-red-800 border border-red-100' :
                              'bg-amber-50 text-amber-800 border border-amber-100'
                            }`}>Refund: {String(status).toUpperCase()}</div>
                          );
                        })()
                      )}
                    </div>
                  ))}
                  {order.items.filter(i => i.returnStatus === 'approved' && i.refundDetails).length === 0 && (
                    <p className="text-xs text-gray-400 bg-gray-50 rounded-xl p-4">No approved returns with bank details yet.</p>
                  )}
                </div>
              </Card>
            )}

            {/* Already refunded */}
            {(order.paymentResult?.refund || order.isRefunded) && (
              <div className="rounded-2xl bg-red-50 border border-red-100 p-5">
                <div className="flex items-center gap-2 text-red-700 mb-3">
                  <Icons.CheckCircle />
                  <span className="text-xs font-bold uppercase tracking-widest">Refund Processed</span>
                </div>
                {order.paymentResult?.refund && (
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <p className="text-[10px] text-red-400 font-bold uppercase tracking-widest mb-1">Refund ID</p>
                      <p className="font-mono text-xs text-red-700 bg-white px-2 py-1 rounded border border-red-100">{order.paymentResult.refund.id}</p>
                    </div>
                    <div>
                      <p className="text-[10px] text-red-400 font-bold uppercase tracking-widest mb-1">Amount</p>
                      <p className="text-xl font-bold text-red-700">₹{order.paymentResult.refund.amount}</p>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {/* ══════════════════════════════════════════════════════════════════
            TAB: CUSTOMER
        ════════════════════════════════════════════════════════════════════ */}
        {activeTab === 'customer' && (
          <div className="max-w-lg space-y-4">
            <Card>
              <div className="p-5 flex items-center gap-4">
                <div className="w-14 h-14 bg-gradient-to-br from-gray-200 to-gray-300 rounded-2xl flex items-center justify-center text-gray-500 shrink-0">
                  <Icons.User />
                </div>
                <div>
                  <p className="text-base font-bold text-gray-900">{order.user?.name || 'Guest User'}</p>
                  <p className="text-xs text-gray-400 mt-0.5">ID: <span className="font-mono">{order.user?._id || 'N/A'}</span></p>
                </div>
              </div>
            </Card>

            <Card>
              <CardHeader title="Contact" />
              <div className="p-5 space-y-2">
                {[
                  { icon: '📧', label: 'Email', value: order.user?.email },
                  { icon: '📱', label: 'Phone', value: order.user?.phone },
                ].map(c => (
                  <div key={c.label} className="flex items-center justify-between bg-gray-50 rounded-xl px-4 py-3 border border-gray-100">
                    <div className="flex items-center gap-3">
                      <span className="w-8 h-8 bg-white rounded-lg flex items-center justify-center text-sm shadow-sm border border-gray-100 shrink-0">{c.icon}</span>
                      <div>
                        <p className="text-[10px] text-gray-400 font-bold uppercase tracking-widest">{c.label}</p>
                        <p className="text-sm font-medium text-gray-900">{c.value || '—'}</p>
                      </div>
                    </div>
                    {c.value && (
                      <button onClick={() => copyToClipboard(c.value)} className="p-1.5 hover:bg-gray-200 rounded-lg transition-colors text-gray-400 hover:text-gray-700">
                        <Icons.Copy />
                      </button>
                    )}
                  </div>
                ))}
              </div>
            </Card>
          </div>
        )}

      </div>{/* end scroll body */}

      <div className="fixed -left-[9999px] top-0 pointer-events-none" aria-hidden="true">
        <div ref={invoiceRef}>
          <div className="w-full max-w-sm mx-auto uppercase" style={{ fontFamily: "'Courier Prime', monospace", letterSpacing: '-0.028em', fontWeight: 'normal', border: '8px solid black', padding: '32px', backgroundColor: 'white' }}>
            <div className="text-center mb-6">
              <img src="/nufab_black.png" alt="NUFAB" className="h-12 mx-auto" crossOrigin="anonymous" />
              <div className="text-base tracking-wider">INVOICE</div>
            </div>

            <div className="flex justify-between text-base mb-4">
              <div>
                <div className="mb-1">BILLED TO:</div>
                <div>ORDER NO.:</div>
              </div>
              <div className="text-right">
                <div className="mb-1">{order.shippingAddress?.name || 'Customer'}</div>
                <div>#{order._id.slice(-6).toUpperCase()}</div>
              </div>
            </div>

            <div className="border-t-2 border-dashed border-black my-4"></div>

            {invoicePricedItems.length > 0 ? (
              <div className="space-y-6">
                {invoicePricedItems.map((item, index) => (
                  <div key={index}>
                    <div className="flex gap-3">
                      {item.image && (
                        <div className="w-36 h-48 overflow-hidden flex-shrink-0">
                          <img src={getOptimizedUrl(item.image || '', 1200)} alt={item.productName} className="w-full h-full object-cover bg-white" />
                        </div>
                      )}

                      <div className="flex-1 flex flex-col justify-between">
                        <div>
                          <div className="text-base">{item.productName}</div>
                          {item.size && <div className="text-base">{item.size}</div>}
                        </div>

                        <div className="text-base">
                          <div className="flex justify-between">
                            <span>UNIT PRICE:</span>
                            <span>{item.originalUnitPrice?.toLocaleString('en-IN')}</span>
                          </div>
                          <div className="flex justify-between">
                            <span>QTY:</span>
                            <span>{item.quantity}</span>
                          </div>
                          <div className="flex justify-between">
                            <span>NET AMOUNT:</span>
                            <span>{item.lineOriginalAmount?.toLocaleString('en-IN')}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {index < invoicePricedItems.length - 1 && (
                      <div className="border-t-2 border-dashed border-black my-4"></div>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-sm text-center py-6">No billable items in this order.</div>
            )}

            <div className="border-t-2 border-dashed border-black my-4"></div>

            <div className="text-sm">
              <div className="flex justify-between">
                <span>SUB TOTAL:</span>
                <span>{invoiceOriginalSubtotal?.toLocaleString('en-IN')}</span>
              </div>
              {invoiceItemDiscountTotal > 0 && (
                <div className="flex justify-between">
                  <span>DISCOUNT:</span>
                  <span>-{invoiceItemDiscountTotal.toLocaleString('en-IN')}</span>
                </div>
              )}
              {invoiceCouponDiscount > 0 && (
                <div className="flex justify-between">
                  <span>{order.couponCode ? `COUPON (${order.couponCode}):` : 'COUPON APPLIED:'}</span>
                  <span>-{invoiceCouponDiscount.toLocaleString('en-IN')}</span>
                </div>
              )}
              <div className="flex justify-between">
                <span>TAX:</span>
                <span>{order.taxPrice && order.taxPrice > 0 ? order.taxPrice.toLocaleString('en-IN') : 'INCLUDED'}</span>
              </div>
              <div className="flex justify-between">
                <span>SHIPPING COST:</span>
                <span>{invoiceShipping === 0 ? 'Free' : invoiceShipping.toLocaleString('en-IN')}</span>
              </div>
            </div>

            <div className="border-t-2 border-dashed border-black my-4"></div>

            <div className="text-sm">
              <div className="flex justify-between text-base mb-1">
                <span>TOTAL:</span>
                <span>{invoiceGrandTotal?.toLocaleString('en-IN')}</span>
              </div>
              <div className="text-sm text-black">(Inc. of all taxes)</div>
            </div>

            <div className="border-t-2 border-dashed border-black my-4"></div>

            <div className="text-sm text-center text-black">
              <div>Order Date: {new Date(order.createdAt).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}</div>
              <div>Payment Method: {order.paymentMethod}</div>
              {order.delhivery?.waybill && <div>Tracking: {order.delhivery.waybill}</div>}
            </div>

            <div className="text-center text-sm text-black mt-8">Thanks for choosing handcraft!</div>
          </div>
        </div>
      </div>

      {/* ── CANCEL RETURN PICKUP MODAL ─────────────────────────────────────── */}
      {showCancelReturnPickupConfirm && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl p-6 max-w-sm w-full shadow-2xl border border-gray-100">
            <p className="text-base font-bold text-gray-900 mb-1">Cancel return pickup?</p>
            <p className="text-sm text-gray-500 mb-5">This will cancel the pickup on Delhivery and remove the AWB. Order reverts to Return Approved.</p>
            <div className="flex gap-3">
              <Btn variant="outline" className="flex-1" onClick={() => setShowCancelReturnPickupConfirm(false)} disabled={actionLoading}>Keep Pickup</Btn>
              <Btn variant="danger" className="flex-1" onClick={handleCancelReturnPickup} disabled={actionLoading}>
                {actionLoading ? <Spinner /> : null} Yes, Cancel
              </Btn>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminOrderDetails;